import React from 'react';
import MouseOutlinedIcon from '@mui/icons-material/MouseOutlined';
import styles from './ScrollableHint.module.scss';

export const ScrollableHint = () => {
  return (
    <span className={styles.hint}>
      <MouseOutlinedIcon fontSize='inherit' />
      Scroll to read the remaining details
    </span>
  );
};
